export const PAGINATION_DEFAULTS = {
    page: 1,
    limit: 12
};
